import prodTemplate from './prod';
import type { AppConfigI } from './example';

const storybook: AppConfigI = {
	...prodTemplate,
	openId: {
		client_id: '',
		authority: '',
		accessTokenExpiringNotificationTime: 1200,
	},
	gaTrackerId: '',
	gtmContainerId: '',
	cartStack: {
		siteId: '',
		trackingScriptUrl: '',
	},
	chatConfig: {
		enabled: false,
		orgId: '',
		deploymentId: '',
		communityURL: '',
		scrt2URL: '',
		messagingScriptURL: '',
		settings: { language: '', chatButtonPosition: '' },
		storageDomain: '',
	},
	algolia: {
		applicationId: '',
		searchOnlyApiKey: '',
	},
	feedback: {
		boardToken: '',
	},
	googleMapsApiKey: 'AIzaSyCp1q6YD7Sqz-XNwB8XV5VCetTr-JcQVMc',
	acceptJs: {
		// eslint-disable-next-line no-underscore-dangle
		__: prodTemplate.acceptJs.__,
		src: 'https://jstest.authorize.net/v1/Accept.js',
		merchantKeys: {
			'33hgGT9J':
				'498uAtfY4Y8dRL327GgmvS2jM3LT2Wcx4Eu525hc7LqD7dUCbXtEeSmDpVKjC5DB',
		},
		fallbackMerchant: {
			key: '498uAtfY4Y8dRL327GgmvS2jM3LT2Wcx4Eu525hc7LqD7dUCbXtEeSmDpVKjC5DB',
			id: '33hgGT9J',
		},
		bankMerchant: {
			id: '2vRE3vqf786K',
			key: '9qdChywENMpdVhGy74rYVm7rjGSwt49R4u937Dk93sZu3GvF8kSYT5yT7P4fJb9u',
		},
	},
	stripe: {
		// eslint-disable-next-line no-underscore-dangle
		__: prodTemplate.stripe.__,
		publishableKey:
			'pk_test_51U0MzhEQjUMOPzmHdu7OQTrrofQnLEnlzMIszA5MVZv230HBj7YwL5t4RqtpAfYvm1Zc83RxndC3V2VszW1hn9wE00cN9PIepU',
	},
};

export default storybook;
